import { render, staticRenderFns } from "./OwnerBusinessesEditBanner.vue?vue&type=template&id=236a021a&"
import script from "./OwnerBusinessesEditBanner.vue?vue&type=script&lang=js&"
export * from "./OwnerBusinessesEditBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports